<template>
  <div class="wrapper">
    <div class="bgc">
      <div class="shop-container">
        <div class="nav-bread">
          <router-link to="/">首页</router-link>
          <span>></span>
          <span>商品详情</span>
        </div>
      </div>
    </div>
    <div class="main bgw">
      <div class="shop-container" v-loading="loadingShow">
        <div class="t">
          <div class="tl">
            <div class="tl-img-box">
              <vue-magnify :previewImg="currentImg" :zoomImg="currentImg"></vue-magnify>
            </div>
            <div class="tl-tabs">
              <div class="prev" @click="!prevDisabled&&scrollPrev" :class="{disabled:prevDisabled}">
                <i class="icon iconfont iconprev"></i>
              </div>
              <div class="next" @click="!nextDisabled&&scrollNext" :class="{disabled:nextDisabled}">
                <i class="icon iconfont iconnext"></i>
              </div>
              <div class="img-list-box">
                <ul class="img-tabs" :style="{width:ulWidth,left:ulLeft+'px'}">
                  <li v-for="(img,index) in productImgList" :key="index" @click="changeShowImg(img)">
                    <img v-lazy="img" alt :key="img">
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="tr">
            <div class="tr-title">{{goodsInfo.name}}</div>
            <div class="tr-desc">{{goodsInfo.brief}}</div>
            <div class="tr-price tr-group">
              <div class="tr-title-left">促销价</div>
              <div class="tr-right">
                <span class="now-price">
                  <i>￥</i>
                  <span class="price-num">{{goodsInfo.price}}</span>
                </span>
                <span class="old-price">
                  <del>￥{{goodsInfo.mktprice}}</del>
                </span>
              </div>
            </div>
            <div class="tr-group underline" v-if="product.promotion_list&&product.promotion_list.length>0">
              <div class="tr-title-left">促销</div>
              <div class="tr-right">
                <span class="cx-item" v-for="(item,index) in product.promotion_list" :key="index">{{item.name}}</span>
              </div>
            </div>
            <!-- <div class="tr-group">
              <div class="tr-title-left">重量</div>
              <div class="tr-right">
                <span class="weight">1.65Kg</span>
              </div>
            </div>-->
            <template v-if="product.default_spes_desc">
              <div class="tr-group" v-for="(value,key,i) in product.default_spes_desc" :key="i">
                <div class="tr-title-left">{{key}}</div>
                <div class="tr-right">
                  <div class="color" v-for="(item,index) in value" :key="index" :class="{'active':item.is_default}" @click="changeSpes(item.product_id)">
                    <a href="javascript:;">{{item.name}}</a>
                  </div>
                </div>
              </div>
            </template>

            <div class="tr-group">
              <div class="tr-title-left">数量</div>
              <div class="tr-right">
                <el-input-number v-model="buyNum" @change="handleChange" :min="1" label="购买数量" size="small" :max="buyMax"></el-input-number>
                <div class="kc">库存{{product.stock}}件</div>
              </div>
            </div>
            <div class="tr-foot">
              <div class="btn add-btn" v-if="goodsInfo.marketable == 1" @click="addToCart" v-show="goodsInfo.is_nomal_virtual!=2">加入购物车</div>
              <div class="btn buy-btn" v-if="goodsInfo.marketable == 1" @click="buyNow">立刻购买</div>

              <div class="btn sold-out" v-if="goodsInfo.marketable == 2">已下架</div>

              <div class="collete-btn" @click="changeFav" v-if="goodsInfo.marketable == 1" :title="isFav?'取消收藏':'添加收藏'">
                <i class="icon iconfont iconshoucang" v-if="isFav"></i>
                <i class="icon iconfont iconshoucang01" v-else></i>
                <div>{{isFav?'已收藏':'收藏'}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="b" style="position:relative">
          <div class="tabs">
            <div class="tab" v-for="(item,index) in tabTitleArr" :key="index" @click="returnTo(item.id)" :class="{active:tabIndex==index}">{{item.name}}</div>
          </div>
          <div style="overflow: hidden;">
            <div class="leaderboard">
              <div class="title">
                销量排行榜
              </div>
              <div class="board">
                <div class="item" v-for="(item,index) in saleRanking" :key="index" @click="toDetails(item.id)">
                  <!-- <div class="number">{{index+1}}</div> -->
                  <div class="img"><img :src="item.image" alt=""></div>
                  <div class="info">
                    <div class="name">{{item.name}}</div>
                    <div class="price">￥{{item.price}}</div>
                    <div class="sold">已售出
                      <span class="num">{{item.buy_count}}</span>
                      件
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="shop-info-wrap" style="width:75%;float:left">
              <div id="detail">
                <div v-if="goodsParams" class="params-wrap">
                  <h3>商品参数</h3>
                  <div v-for="(item,index) in goodsParams" :key="index" class="params-content">{{item.name}}：{{item.value}}</div>
                </div>
                <div class="shop-info-item" v-show="tabIndex==0" v-html="goodsInfo.intro"></div>
              </div>

              <div class="shop-info-item" id="comment">
                <h3>晒单评价</h3>
                <div v-if="goodsComments.count==0">
                  <div class="no-comment">暂无评价</div>
                </div>
                <div v-for="(item,index) in goodsComments.list" :key="index" class="comment" v-else>
                  <div class="user">
                    <div class="user-head">
                      <img :src="item.user.avatar" alt>
                    </div>
                    <span class="user-name">{{item.user.nickname}}</span>
                  </div>
                  <div class="detail">
                    <div class="score">
                      <el-rate v-model="item.score" disabled></el-rate>
                    </div>
                    <div class="content">{{item.content}}</div>
                    <div v-if="item.images_url" class="img-list">
                      <div v-for="(img,i) in item.images_url" :key="i" class="img-li" @click="changeBigImg(img,i,index,item)" :class="{'active':img==item.currentImg}">
                        <img :src="img" alt>
                      </div>
                    </div>
                    <transition name="img-zoom">
                      <div v-show="item.showBigImg" class="big-img" :class="{'hidden':!item.showBigImg}">
                        <img :src="item.currentImg" alt>
                      </div>
                    </transition>

                    <div class="time">
                      <span class="addon" v-if="item.addon">{{item.addon}}</span>
                      {{item.ctime}}
                    </div>
                  </div>
                </div>
              </div>

            </div>
            
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in">
      <div class="scrollTop" v-show="toTopShow" @click="scrollToTop">
        <i class="icon iconfont iconfanhuidingbu"></i>
        <p>顶部</p>
      </div>
    </transition>
  </div>
</template>

<script>
import vueMagnify from '@/components/vue-magnify/index.vue'
import { timeToDate } from '@/utils'
import { mapActions } from 'vuex'
export default {
  name: 'ProductDetail',
  components: { vueMagnify },
  props: {},
  data() {
    return {
      toTopShow: false,
      buyNum: 1,
      tabTitleArr: [
        {
          id: 'detail',
          name: '商品详情',
        },
        {
          id: 'comment',
          name: '评论晒单',
        },
      ],
      tabIndex: 0,
      goodsId: '',
      imgList: [],
      ulLeft: 0,
      isEnd: false,
      goodsInfo: {}, //商品详情
      product: {}, // 规格详情
      isFav: false, //收藏
      goodsParams: null, //商品参数信息
      goodsComments: {
        count: 0,
        page: 1,
        limit: 15,
        list: null,
      }, // 商品评论信息, //商品评论信息
      currentImg: '', //列表选中图片
      selectCommentImg: '', //评论选中图片
      selectCommentImgIndex: null, //评论选中图片
      selectCommentIndex: null, //评论选中图片
      loadingShow: false,
      saleRanking: [], //销量排行榜
    }
  },
  watch: {
    $route(to, from) {
      if (to.name == 'detail') {
        let goodsId = this.$route.params.goodsId
        if (goodsId) {
          this.goodsId = goodsId
          this.getAllInfo()
        }
      }
      if (this.$route) {
        this.buyNum=1
      }
    },
  },
  computed: {
    ulWidth() {
      if (this.goodsInfo.album) {
        return this.goodsInfo.album.length * 62 + 'px'
      }
      return 0 + 'px'
    },
    prevDisabled() {
      return this.ulLeft == 0
    },
    nextDisabled() {
      if (this.goodsInfo.album) {
        return this.goodsInfo.album.length <= 5 || this.isEnd
      }
      return false
    },
    buyMax() {
      return this.product.stock
    },
    productImgList() {
      return this.goodsInfo.album
    },
  },
  methods: {
    ...mapActions(['getCartNumsAction']),
    handleChange(value) {},
    scrollPrev() {
      this.ulLeft = 0
    },
    scrollNext() {
      let num = this.productImgList.length - 5
      let left = 54 * num + 24
      this.ulLeft = -left
      this.isEnd = true
    },
    addToCart() {
      let data = {
        product_id: this.product.id,
        nums: this.buyNum,
      }
      this.$api.addCart(data).then(res => {
        if (res.status) {
          this.getCartNums()
          this.$router.push({
            path: '/buySuccess',
            query: { goodsName: this.goodsInfo.name },
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    buyNow() {
      let data = {
        product_id: this.product.id,
        nums: this.buyNum,
        type: 2, // 区分加入购物车和购买
      }
      this.$api.addCart(data).then(res => {
        if (res.status) {
          let cartIds = res.data
          this.$router.push({
            name: 'order',
            query: { cart_ids: JSON.stringify(cartIds) },
          })
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data)
        }
      })
    },
    //切换评论图片大图
    changeBigImg(img, i, index, item) {
      if (img == item['currentImg']) {
        this.$set(item, 'showBigImg', false)
        this.$set(item, 'currentImg', '')
      } else {
        this.$set(item, 'showBigImg', true)
        this.$set(item, 'currentImg', img)
      }
      // if (this.selectCommentIndex == index) {
      // } else {
      //   this.selectCommentImg = img;
      //   this.selectCommentImgIndex = i;
      // }

      this.selectCommentIndex = index
    },
    //切换显示图片
    changeShowImg(img) {
      this.currentImg = img
    },
    returnTo(id) {
      // document.getElementById(id).scrollIntoView({behavior: "smooth"})
      document.getElementById(id).scrollIntoView()
    },
    //获取商品参数
    getGoodsParams() {
      let data = { id: this.goodsId }
      this.$api.goodsParams(data).then(res => {
        if (res.status) {
          this.goodsParams = res.data
        }
      })
    },
    getGoodsComments() {
      let data = {
        page: this.goodsComments.page,
        limit: this.goodsComments.limit,
        goods_id: this.goodsId,
      }
      this.$api.goodsComment(data).then(res => {
        if (res.status) {
          let _list = res.data.list
          _list.forEach(item => {
            item.ctime = timeToDate(item.ctime)
            this.$set(item, 'showBigImg', false)
            this.$set(item, 'currentImg', '')
          })
          this.goodsComments.list = _list
          this.goodsComments.count = res.data.count
        }
      })
    },
    //商品详情
    getGoodsDetail() {
      let data = {
        id: this.goodsId,
      }
      let userToken = this.$storage.get('userToken')
      if (userToken) {
        data['token'] = userToken
      }
      this.loadingShow = true
      this.$api.goodsDetail(data).then(res => {
        if (res.status == true) {
          this.loadingShow = false
          let info = res.data
          this.goodsInfo = info
          this.product = res.data.product
          this.isFav = info.isfav === 'true' ? true : false
          this.currentImg = this.goodsInfo.album[0]
          if (this.$storage.get('userToken')) {
            this.goodsBrowsing()
          }
        }
      })
    },
    goodsBrowsing() {
      let data = {
        goods_id: this.goodsInfo.id,
      }
      this.$api.addGoodsBrowsing(data).then()
    },
    //切换商品规格
    changeSpes(id) {
      this.$api.getProductInfo({ id }).then(res => {
        if (res.status) {
          this.product = res.data
        }
      })
    },
    //切换收藏
    changeFav() {
      let data = {
        goods_id: this.goodsInfo.id,
      }
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.isFav = !this.isFav
        }
      })
    },
    getAllInfo() {
      this.getGoodsDetail()
      this.getGoodsParams()
      this.getGoodsComments()
    },
    handleScroll() {
      this.scrollTop = this.scrollTop =
        window.pageYOffset || document.body.scrollTop
      if (this.scrollTop > 500) {
        this.toTopShow = true
      } else {
        this.toTopShow = false
      }
    },
    scrollToTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    // 获取销量排行榜
    getSalesRanking() {
      this.$api.getSalesRanking({}).then(res => {
        if (res.status) {
          this.saleRanking = res.data
        }
      })
    },
    toDetails(id) {
      this.$router.push({
        name: 'detail',
        params: { goodsId: id },
      })
    },
  },
  created() {},
  mounted() {
    let goodsId = this.$route.params.goodsId
    this.goodsId = goodsId
    this.getAllInfo()
    this.$nextTick(function() {
      window.addEventListener('scroll', this.handleScroll)
    })
    // 获取销量排行榜
    this.getSalesRanking()
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.img-zoom-enter-active,
.img-zoom-leave-active {
  width: 100%;
  transition: all 0.2s linear;
}
.img-zoom-enter,
.img-zoom-leave-to {
  width: 0;
  opacity: 0;
}
.scrollTop {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: $theme-color;
  text-align: center;
  color: #fff;
  z-index: 999;
  cursor: pointer;
  .icon {
    display: block;
    margin-top: 12px;
    margin-bottom: 5px;
  }
  p {
    font-size: 12px;
  }
}
.comment {
  display: flex;
  border-bottom: 1px solid $border;
  padding: 15px 0;
  .user {
    display: inline-flex;
    .user-head {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
      overflow: hidden;
      img {
        display: block;
        width: 40px;
        height: 40px;
        object-fit: cover;
      }
    }
    .user-name {
      display: inline-block;
      color: #757575;
      font-size: 12px;
      width: 75px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .detail {
    flex: 1;
    .content {
      padding: 10px 0;
    }
    .img-list {
      margin: 10px 0;
      display: inline-flex;
      .img-li {
        width: 52px;
        height: 52px;
        margin-right: 10px;
        margin-bottom: 5px;
        border: 1px solid $border;
        padding: 2px;
        &.active {
          padding: 1px;
          border: 2px solid $theme-color;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .big-img {
      max-width: 300px;
      border: 1px solid $border;
      padding: 2px;
      &.hidden {
        border: none;
        padding: 0;
      }
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
      }
    }
    .time {
      color: #999;
      font-size: 12px;
      margin-top: 10px;
      .addon {
        margin-right: 20px;
      }
    }
  }
}

.wrapper {
  .main {
    padding-top: 14px;
    .t {
      display: flex;
      padding-bottom: 30px;
      .tl {
        margin-right: 20px;
        .tl-img-box {
          width: 350px;
          height: 350px;
          border: 1px solid $border;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .tl-tabs {
          height: 54px;
          position: relative;
          .img-list-box {
            width: 310px;
            height: 54px;
            margin: 0 auto;
            position: relative;
            overflow: hidden;
            padding-bottom: 4px;
            ul {
              position: absolute;
              left: 0;
              top: 0;
              height: 54px;
              transition: left 0.15s linear;
              li {
                width: 54px;
                height: 54px;
                float: left;
                margin: 0 4px;
                border: 1px solid $border;
                padding: 1px;
                box-sizing: border-box;
                &:hover {
                  border: 2px solid $theme-color;
                  padding: 0;
                }
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
          }
          .prev {
            position: absolute;
            left: -5px;
            top: 50%;
            width: 26px;
            height: 26px;
            margin-top: -16px;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              .icon {
                color: $border;
              }
            }
            .icon {
              font-size: 26px;
              color: #757575;
            }
          }
          .next {
            position: absolute;
            right: -5px;
            top: 50%;
            width: 26px;
            height: 26px;
            margin-top: -16px;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              .icon {
                color: $border;
              }
            }
            .icon {
              font-size: 26px;
              color: #757575;
            }
          }
        }
      }
      .tr {
        flex: 1;
        position: relative;
        .tr-title {
          font-weight: 700;
          color: #666;
          padding-top: 10px;
          line-height: 28px;
          font-size: 18px;
          margin-bottom: 5px;
        }
        .tr-desc {
          font-size: 14px;
          margin-bottom: 20px;
        }
        .tr-group {
          margin-bottom: 15px;
          position: relative;
          display: flex;
          &.underline {
            padding-bottom: 10px;
            border-bottom: 1px solid $border;
          }
          .tr-title-left {
            color: #838383;
            font-size: 12px;
            display: inline-block;
            width: 60px;
            height: 32px;
            line-height: 32px;
          }
          .tr-right {
            display: inline-block;
            flex: 1;
            .now-price {
              color: $theme-color;
              text-align: left;
              margin-right: 20px;
              i {
                font-size: 16px;
              }
              .price-num {
                font-size: 22px;
              }
            }
            .old-price {
              color: #666;
              font-size: 12px;
            }
            .cx-item {
              padding: 2px 4px;
              background: $theme-color;
              color: #fff;
              margin-right: 10px;
              font-size: 12px;
              height: 24px;
              line-height: 24px;
            }
            .color,
            .size {
              font-size: 12px;
              border: 1px solid #b8b7bd;
              margin-right: 8px;
              display: inline-block;
              height: 28px;
              line-height: 28px;
              margin-bottom: 12px;
              &.active {
                border-color: $theme-color;
                background: $theme-color;
                color: #fff;
              }
              a {
                display: block;
                padding: 0 10px;
              }
              &:hover {
                border: 1px solid $theme-color;
              }
            }
            .weight {
              font-size: 12px;
            }
            .kc {
              color: #878787;
              display: inline-block;
              font-size: 12px;
              margin-left: 20px;
            }
          }
        }
      }
    }
  }
}
.tr-foot {
  display: flex;
  position: absolute;
  bottom: 0;
  .btn {
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    width: 180px;
    text-align: center;
    border: 1px solid $theme-color;
    margin-right: 20px;
    cursor: pointer;
    &.add-btn {
      color: $theme-color;
    }
    &.buy-btn {
      background: $theme-color;
      color: #fff;
    }
    &.sold-out {
      background: $theme-color;
      color: #fff;
      cursor: not-allowed;
      border: none;
    }
  }
  .collete-btn {
    width: 45px;
    height: 47px;
    text-align: center;
    padding-top: 5px;
    box-sizing: border-box;
    font-size: 12px;
    background: #fff;
    border: 1px solid $border;
    color: #bebebe;
    cursor: pointer;
    color: $theme-color;
    .icon {
      display: block;
      margin-bottom: 4px;
    }
    &:hover {
      color: $theme-color;
    }
  }
}
.b {
  padding: 20px 0;
  border-top: 1px solid $border;
  .tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    .tab {
      font-size: 16px;
      padding: 0px 15px;
      cursor: pointer;
      &:not(:last-of-type) {
        border-right: 1px solid $border;
      }
      &.active,
      &:hover {
        color: $theme-color;
      }
    }
  }
  .shop-info-wrap {
    border: 1px solid $border;
    padding: 20px;
    .params-wrap {
      padding: 15px 0;
      border-bottom: 1px solid $border;
      margin-bottom: 20px;
      h3 {
        margin-bottom: 10px;
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        padding-left: 20px;
      }
      .params-content {
        padding-left: 20px;
        color: #757575;
        font-size: 12px;
        margin: 10px 0;
      }
    }
    #comment {
      padding: 15px 0;
      h3 {
        height: 30px;
        line-height: 30px;
        background: #f7f7f7;
        padding-left: 20px;
      }
      .no-comment {
        padding-left: 20px;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
.leaderboard {
  float: left;
  width: 21%;
  margin-right: 7px;
  .title {
    background-color: #eee;
    line-height: 40px;
    padding: 0 5px;
  }
  .board {
    border: 1px solid #dee2e9;
    background-color: #fff;
    .item:last-child {
      border: none;
    }
    .item {
      display: flex;
      justify-content: flex-start;
      border-bottom: 1px solid #dee2e9;
      padding: 10px;
      cursor: pointer;
      .number {
        background-color: #333;
        color: #fff;
        width: 20px;
        text-align: center;
        height: 20px;
        line-height: 20px;
      }
      .img {
        width: 150px;
        // height: 150px;
        object-fit: cover;
        // border: 1px solid #dee2e9;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .info {
        width: 63%;
        margin-left: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .name {
          width: 100%;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: #666;
          font-size: 12px;
        }
        .price {
          color: #ff7159;
        }
        .sold {
          color: #666;
          font-size: 12px;
          .num {
            color: #ff7159;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.preview-box {
  img {
    height: 350px;
    object-fit: cover;
  }
}
</style>